import { Injectable } from '@angular/core';

@Injectable()
export class DefaultRangeService {

  constructor() { }

  public get month() {
    const currentDate = new Date();
    const lastMonth = new Date(new Date(currentDate).setMonth(currentDate.getMonth() - 1));
    const beginDate = new Date(lastMonth.getFullYear(), lastMonth.getMonth(), lastMonth.getDate());
    const endDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    return {
      beginDate,
      endDate
    };
  };

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/daterange/default-range.service.ts